// Interfaces
import {
    IAccessTokenRequest,
    ITokenResponse,
    ITokenUserInfo,
    IUserToken,
    IGetUserTokenRequest,
    ILogoutRedirectInterface,
    ILogoutStatus,
} from '../interfaces/login.interfaces';
import * as api from './middleware/api.middleware';
// Config
import { staticConfig } from '../config/static';
// Helpers
import { IMiddlewareOptions } from './middleware/interfaces';

const serviceUrl = '/loginservice/v2';

const authenticationRequest = (data: IAccessTokenRequest) => {
    return api.post<ITokenResponse>(`${serviceUrl}/connect/token`, data, null, getMiddlewareOptions(false));
};

export function getMiddlewareOptions(isUrlExclusive: boolean, noCredentials = false): IMiddlewareOptions {
    const options: IMiddlewareOptions = {
        errorCodeOptions: {
            errorCodeComponentContext: null,
            errorCodesHandled: [400, 401],
        },
        options: { isUrlExclusive },
        noCredentials: noCredentials,
    };

    return options;
}

export function getAccessToken(accessCode: string): Promise<ITokenResponse> {
    const getAccessTokenRequestData: IAccessTokenRequest = {
        code: encodeURIComponent(accessCode),
        grant_type: 'authorization_code',
        redirect_uri: staticConfig.appBaseUrl.slice(0, -1),
        code_verifier: encodeURIComponent(sessionStorage.getItem('codeVerifier')),
        nonce: sessionStorage.getItem('codeNonce'),
    };
    return authenticationRequest(getAccessTokenRequestData);
}

export function getLogonPlace() {
    const params = new URLSearchParams(window.location.search);
    const identityType = params.get('identitytype')?.toLowerCase();
    const classicLogonPlace = localStorage.getItem('classicLogonPlace');

    if (!identityType && classicLogonPlace) return;

    let urlSegment = identityType === 'p' ? 'privat' : 'privat';
    urlSegment = identityType === 'v' ? 'erhverv' : 'privat';

    localStorage.setItem('classicLogonPlace', urlSegment);
}

export function getUserInfo() {
    return api.get<ITokenUserInfo>(`${serviceUrl}/connect/userinfo`);
}

export function getUserToken(userTokenRequest: IGetUserTokenRequest) {
    return api.post<IUserToken>(serviceUrl + '/connect/usertoken', userTokenRequest, getMiddlewareOptions(false));
}

export function getLogoutURL() {
    return api.get<ILogoutRedirectInterface>(`${serviceUrl}/logout`);
}

export function getLogoutDone() {
    return api.get<ILogoutStatus>(`${serviceUrl}/logoutdone`);
}
